import { boolPropsToClassNames } from 'common/utils/style.utils';
import { OVER_TIME_TYPES } from '../useProgressionOverTime/state.types';
import {
  StyledType,
  StyledTypeSelector,
  StyledTypeText
} from './TypeSelector.style';
import { useSelector } from 'react-redux';
import { pmToolSensorIdSelector } from 'state/selectors/sensors-authorizations';

const TypeSelector = ({ type, setType }) => {
  const pmProvider = useSelector(pmToolSensorIdSelector);
  return (
    <StyledTypeSelector>
      {Object.values(OVER_TIME_TYPES[pmProvider]).map(currType => {
        const isSelected = currType.key === type.key;
        return (
          <StyledType key={currType.key}>
            <StyledTypeText
              className={boolPropsToClassNames({ isSelected })}
              {...(isSelected ? {} : { onClick: () => setType(currType) })}
            >
              {currType.name}
            </StyledTypeText>
          </StyledType>
        );
      })}
    </StyledTypeSelector>
  );
};

export default TypeSelector;
